export const NAME_SPACE = 'systemSettings.grid-and-system-protection-configuration.active-power-settings'
